import 'owl.carousel';
import { counter } from './page';

export function sliders()
{
	let sliders = $('.slider');

	sliders.each(function()
	{
		let sliderNav = $(this).attr('data-nav');
		let parent = $(this).parents('.content-slider');
		
		let dataNav = sliderNav == 'false' ? false : true;

		let options = {
			items: 1,
			dots: false,
			nav: dataNav,
			touchDrag: dataNav,
			mouseDrag: dataNav,
			loop: true,
			navText: ['<svg viewBox="0 0 8.07 15.61"><use xlink:href="#larr" /></svg>','<svg viewBox="0 0 8.07 15.61"><use xlink:href="#rarr" /></svg>'],
		};

		if( sliderNav != null && sliderNav != false )
		{
			options.navContainer = parent.find(`.${sliderNav}`);
		}

		$(this).owlCarousel(options);

		$(this).on('translated.owl.carousel', function(event)
		{
			let target = event.target;
			
			if( $(target).hasClass('impact-slider') )
			{
				let active = $(this).find('.owl-item.active');
				
				if( !active.hasClass('visited') )
				{
					counter(active);
				}
			}

		});
	});


	$('.slide__overlay').on('click', function() {

		let video_player = $(this).parents('.slide').find('iframe');
        let old_src = video_player.attr('src');
        let new_src = old_src.concat('&autoplay=1');

        video_player.attr('src', new_src);

        $(this).addClass('disabled');
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/sliders.js